module.exports = __webpack_public_path__ + "media/images/writer-offering-merit02-f76774eddd6fed202701ca043eebd691.png";